export default __webpack_public_path__ + "static/media/SHOT3.4857702a.png";